import "./App.css";
import AllRoutes from "./AllRoutes";
//import history from "./history";

function App() {
  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}

export default App;
